import { useEffect, useRef } from "react";

export const useOnOpen = (open: boolean, onOpen: () => void) => {
	const wasOpenRef = useRef(open);
	const onOpenRef = useRef(onOpen);
	onOpenRef.current = onOpen;

	useEffect(() => {
		const wasClosed = !wasOpenRef.current;
		wasOpenRef.current = open;
		if (open && wasClosed) onOpenRef.current();
	}, [open]);
};
